export default __webpack_public_path__ + "static/media/logo.c98e8e15.png";